export default "__VITE_ASSET__00de8c1a__"